import {PageStandard} from "../utils/PageStandard";


export function Page404() {
    return (
        <PageStandard title="404" sidebarVisible={true}>
            Pagina non trovata
        </PageStandard>
    )
}